<script>
import CustomersApi from "@/services/customers-api";
import CountriesApi from "@/services/countries-api";
import i18n from "@/i18n";
import ReportingApi from "@/services/reporting-api";

export default {
    mounted(){
        this.getCurrency()

        this.role=sessionStorage.getItem("userr");
        if(this.role == 1){
          this.getCustomers()
          this.getCountries();
        }
        this.getInvoicesStatus()

    } ,

    computed: {
    columnChart() {
        return [
                {
                series: [
                {
                    name: i18n.t('invoicesMenu.types.bill'),
                    data: this.unpaidData
                }, {
                    name: i18n.t('invoicesMenu.types.creditBill'),
                    data: this.inprogressData
                }
                ],
                chartOptions: {
                    chart: {
                        toolbar: {
                            show: false,
                        }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            columnWidth: '30%',
                            endingShape: 'rounded'
                        },
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                    },
                    colors: ['#34c38f','#fec235','#34c38f'],
                    xaxis: {
                        categories: [i18n.t('months.0'), 
                                    i18n.t('months.1'), 
                                    i18n.t('months.2'), 
                                    i18n.t('months.3'), 
                                    i18n.t('months.4'), 
                                    i18n.t('months.5'), 
                                    i18n.t('months.6'), 
                                    i18n.t('months.7'), 
                                    i18n.t('months.8'),
                                    i18n.t('months.9'),
                                    i18n.t('months.10'),
                                    i18n.t('months.11')],
                    },
                    yaxis: {
                        title: {
                            text: i18n.t('invoiceState.yaxis.title.text')+" "+this.currency,
                            style: {
                                fontWeight: '500',
                            },
                        },
                        labels: {
                            formatter: function(val) {
                                return val.toFixed(0)
                            }
                        },
                    },
                    grid: {
                        borderColor: '#f1f1f1',
                    },
                    fill: {
                        opacity: 1
                    },
                    tooltip: {
                        y: {
                            formatter: function (val) {
                                return val.toFixed(3)
                            }
                        }
                    }
                }
            }
        ]

        }
},

   data(){
        return{
            customersList:[],
            selectedCustomer:null,
            selectedCountry:null,
            selectedCity:null,
            citiesList:[],
            countriesList:[],
            role:null,
            loading_sources:false,
            billsData:[],
            creditbillssData:[],
            currency:""
        };
    },
      methods:{
        getCustomers(){
        CustomersApi.getCustomers(this.selectedCountry==null ? null : this.selectedCountry.id,this.selectedCity==null ? null : this.selectedCity.id).then(
            response => {
            this.customersList=response;
            }
        )
        },
        getCountries(){
        CountriesApi.getCountries().then(
            result => {
                this.countriesList = result
            })
        },
        getCities(){
        CountriesApi.getCities(this.selectedCountry ? this.selectedCountry.id : null).then(
            result => {
                this.citiesList = result
            })
        },

        getInvoicesStatus(){
            ReportingApi.getInvoicesStatus(this.selectedCountry==null ? null : this.selectedCountry.id,this.selectedCity==null ? null : this.selectedCity.id,this.selectedCustomer==null ? null : this.selectedCustomer.id).then(

                (result)=>{
                    if(result){

                        this.loading_sources=false
                        this.columnChart[0].series[0].data=[]
                        this.billsData=[]
                        this.columnChart[0].series[0].data= result["billsList"]
                        this.unpaidData=result["billsList"]

                        this.creditbillssData=[]
                        this.columnChart[0].series[1].data=[]
                        this.columnChart[0].series[1].data= result["creditBillsList"]  
                        this.creditbillssData=result["creditBillsList"]  


                    }
                
                }
                
            ).finally(()=>{
                this.loading_sources=true
            })
        },

        getCurrency(){
            CustomersApi.getCustomerCurrency().then(
            result => {
                if(result){
                this.currency=result;
                }
                
            }
            )
        }
    },

    watch: {
        selectedCountry: function(){
          this.getInvoicesStatus()
          this.getCustomers()
          if(this.selectedCountry != null){
            this.getCities()
          }else{
            this.selectedCity=null
            this.citiesList=[]
          }
        },
        selectedCity: function(){
            this.getCustomers()
            if(this.selectedCountry!=null){
              this.getInvoicesStatus()
            }
        },
        selectedCustomer: function(){
          this.getInvoicesStatus()

        }
    }
}
</script>
<template>
    <div class="clearfix m-4">
        <div class="row">
            <div class="col-12">
                <h4 class="card-title mb-2 font-size-18 font-weight-bold text-primary">{{$t('invoiceState.title')}} en ({{this.currency}})</h4>
            </div>
        </div>
        <div v-if="role==1" class="row mt-4">
            <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 pr-lg-2">
                <b-form-group label="" label-for="">
                    <v-select :options="countriesList" :placeholder="$t('lists.countries.label')" label="name" v-model="selectedCountry">
                    <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                    </v-select>
                </b-form-group>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 pr-lg-2">
                <b-form-group label="" label-for="">
                    <v-select :options="citiesList" :placeholder="$t('lists.cities.label')" label="name" v-model="selectedCity">
                    <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                    </v-select>
                </b-form-group>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 pr-lg-2">
                <b-form-group label="" label-for="">
                    <v-select :options="customersList" :placeholder="$t('lists.customers.label')" label="companyName" v-model="selectedCustomer">
                    <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                    </v-select>
                </b-form-group>
            </div>
        </div>
        <div class="invisible row text-center" >
          <div class="col-sm-6 col-xs-12 pr-2">
            <b-form-group  label-for="">
              <b-form-datepicker
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright
                hide-header
              ></b-form-datepicker>
            </b-form-group>
          </div>
          <div class="col-sm-6 col-xs-12 ">
            <b-form-group  label-for="">
              <b-form-datepicker
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright                         
                hide-header
              ></b-form-datepicker>
            </b-form-group>
          </div>
      </div>
        <apexchart
            class="apex-charts"
            height="350"
            type="bar"
            dir="ltr"
            v-if="loading_sources"
            :series="columnChart[0].series"
            :options="columnChart[0].chartOptions"
        ></apexchart>
        <div v-if="!loading_sources" class="text-center my-2">
            <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
        </div>
    </div>
</template>